import type { TMessages } from '@/types/TMessages'

export const messages = {
  comment: 'Заявка с шапки сайта',
  menu: {
    title: 'Меню',
    link: {
      profile: 'Личный кабинет',
      fertilizers: 'Сельхозтовары',
      harvestSale: 'Продажа урожая',
      priceRequests: 'Запросы цен',
      financing: 'Кредиты и лизинг',
      journal: 'Журнал',
      feedback: 'Обратная связь',
      financingItems: {
        money: {
          title: 'Деньги без ежемесячных платежей',
          subText: 'до 200 млн руб за 5 рабочих дней',
        },
        consult: {
          title: 'Бесплатная консультация фин. эксперта',
          subText: 'Поможем с подбором финансового продукта',
        },
        self: {
          title: 'Самостоятельно подобрать решение',
          subText: 'Другие финансовые продукты',
        },
      },
    },
  },
} as const satisfies TMessages
